import { render, staticRenderFns } from "./LaundryUserManagement.vue?vue&type=template&id=990be5ba&scoped=true"
import script from "./LaundryUserManagement.vue?vue&type=script&lang=js"
export * from "./LaundryUserManagement.vue?vue&type=script&lang=js"
import style0 from "./LaundryUserManagement.vue?vue&type=style&index=0&id=990be5ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990be5ba",
  null
  
)

export default component.exports